import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import moment from 'moment';
import { customerResource } from '@/views/system/customerManage/request';
import { policyNoResource, personnelDetailExport, personnelDetailsRecordPrompt, endorsementCreate, checkAndPreviewEndorsement, endorsementExportSend, exportSendEmail } from './request';
import { checkEmail } from '@/utils/validate';
import { downloadFileFun } from '@/utils/public';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    customerId: {}
  },
  watch: {
    async visible(newV) {
      if (newV) {
        const res = await customerResource({});
        this.customerList2 = res;
        this.policyNoResourceFn();
        this.form.policyNo = undefined;
        this.form.time = [];
        this.form.customerId = this.customerId;
      }
      this.showVisible = newV;
    },
    customerId(newV) {
      this.form.customerId = newV;
    }
  },
  data() {
    return {
      form: {
        time: [],
        customerId: undefined,
        policyNo: undefined
      },
      showVisible: false,
      customerList2: [],
      policyNoList: [],
      tipVisible: false,
      importStatus: '',
      requestInfo: {},
      count: 0,
      loading: false,
      completeTitle: '',
      isSendEmailShow: false,
      checkTypeOne: false,
      checkTypeTwo: false,
      exportLoading: false,
      receivingEmails: ''
    };
  },
  methods: {
    disabledDate(current) {
      return current && current > moment().endOf('day') || current && current < moment().subtract(1, 'months').subtract(1, 'day');
    },
    async onExport() {
      if (!this.form.policyNo) {
        return this.$message.warn(this.$t('请选择') + this.$t('保单号'));
      }
      if (!this.form.time.length) {
        return this.$message.warn(this.$t('请选择') + this.$t('日期范围'));
      }
      let obj = {
        customerId: this.form.customerId,
        policyNo: this.form.policyNo,
        createAt: moment(this.form.time[0]).format('YYYY-MM-DD'),
        endAt: moment(this.form.time[1]).format('YYYY-MM-DD')
      };
      this.exportLoading = true;
      const prompt = await personnelDetailsRecordPrompt(obj).finally(() => {
        this.exportLoading = false;
      });
      if (prompt) {
        var _this$customerList2$f;
        this.exportLoading = true;
        const res = await personnelDetailExport(obj).finally(() => {
          this.exportLoading = false;
        });
        let name = (_this$customerList2$f = this.customerList2.find(i => i.id == this.form.customerId)) === null || _this$customerList2$f === void 0 ? void 0 : _this$customerList2$f.name;
        downloadFileFun(res, 'application/vnd.ms-excel', name + obj.createAt + this.$t('增减员明细') + '.xlsx');
      }
    },
    changeCustomerId() {
      this.form.policyNo = undefined;
      this.form.time = [];
      this.policyNoResourceFn();
    },
    async policyNoResourceFn() {
      const res = await policyNoResource({
        customerId: this.form.customerId
      });
      this.policyNoList = res;
    },
    preview() {
      if (!this.form.policyNo) {
        return this.$message.warn(this.$t('请选择') + this.$t('保单号'));
      }
      if (!this.form.time.length) {
        return this.$message.warn(this.$t('请选择') + this.$t('日期范围'));
      }
      let params = {
        customerId: this.form.customerId,
        createAt: moment(this.form.time[0]).format('YYYY-MM-DD'),
        endAt: moment(this.form.time[1]).format('YYYY-MM-DD'),
        policyNo: this.form.policyNo,
        anchorPoint: 'POLICY_PREVIEW'
      };
      let currentCount = this.count++;
      this.loading = true;
      this.tipVisible = true;
      this.$set(this.requestInfo, 'type', 'preview');
      this.$set(this.requestInfo, 'loadingTip', '批单生成中,请耐心等待 不要退出该页面');
      this.importStatus = '';
      checkAndPreviewEndorsement(params).then(res => {
        this.loading = false;
        if (res && res.fileTempUrl && this.count - 1 === currentCount) {
          this.importStatus = 'SUCCESS';
          this.completeTitle = '生成成功';
          window.open(res.fileTempUrl);
          // window.location.href = url;
        }
      }).catch(e => {
        this.loading = false;
        this.importStatus = 'ERROR';
        this.completeTitle = '生成失败';
      });
    },
    handleMenuClick(type) {
      if (!this.form.policyNo) {
        return this.$message.warn(this.$t('请选择') + this.$t('保单号'));
      }
      if (!this.form.time.length) {
        return this.$message.warn(this.$t('请选择') + this.$t('日期范围'));
      }
      let params = {
        customerId: this.form.customerId,
        createAt: moment(this.form.time[0]).format('YYYY-MM-DD'),
        endAt: moment(this.form.time[1]).format('YYYY-MM-DD'),
        policyNo: this.form.policyNo,
        anchorPoint: type.key === 'create' ? 'POLICY_GENERATE' : 'POLICY_GENERATE_SEND'
      };
      this.loading = true;
      this.tipVisible = true;
      this.$set(this.requestInfo, 'type', type.key);
      let currentCount = this.count++;
      let loadingTip = type.key === 'create' ? '批单生成中,请耐心等待 不要退出该页面' : '批单生成中,请耐心等待 不要重复点击发送';
      this.$set(this.requestInfo, 'loadingTip', loadingTip);
      this.importStatus = '';
      checkAndPreviewEndorsement(params).then(res => {
        if (res && res.checkStatus && type.key === 'createAndSend' && this.count - 1 === currentCount) {
          this.createAndSend(params, currentCount);
        } else if (res && res.checkStatus && type.key === 'create' && this.count - 1 === currentCount) {
          this.createEndorsementDownload(params, currentCount);
        } else if (this.count - 1 === currentCount) {
          this.importStatus = 'ERROR';
        }
      }).catch(e => {
        this.importStatus = 'ERROR';
        this.loading = false;
      });
      return;
    },
    createAndSend(params, currentCount) {
      endorsementExportSend(params).then(res => {
        this.loading = false;
        if (res && res.fileTempUrl && this.count - 1 === currentCount) {
          this.importStatus = 'SUCCESS';
          this.$set(this.requestInfo, 'url', res.fileTempUrl);
        } else if (this.count - 1 === currentCount) {
          this.importStatus = 'ERROR';
          this.$message.error(res.data && res.data.message);
        }
      }).catch(e => {
        this.loading = false;
        this.importStatus = 'ERROR';
      });
    },
    tipChange() {
      if (this.requestInfo.type === 'createAndSend') {
        window.open(this.requestInfo.url, '_self');
      } else {
        this.tipVisible = false;
      }
    },
    createEndorsementDownload(params, currentCount) {
      endorsementCreate(params).then(res => {
        this.loading = false;
        if (res && res.data && res.status === 200 && this.count - 1 === currentCount) {
          this.importStatus = 'SUCCESS';
          let fileName = decodeURIComponent(res.headers['content-disposition'].split(';')[1].split('=')[1].replace(/^\"|\"$/g, '').replace(/utf-8''/, ''));
          downloadFileFun(res.data, 'application/msword', fileName);
        } else if (this.count - 1 === currentCount) {
          this.importStatus = 'ERROR';
          this.$message.error(res.data && res.data.message);
        }
      }).catch(e => {
        this.loading = false;
        this.importStatus = 'ERROR';
      });
    },
    changeShow() {
      if (this.isSendEmailShow) {
        this.isSendEmailShow = false;
        this.receivingEmails = '';
        this.checkTypeOne = false;
        this.checkTypeTwo = false;
      } else {
        this.isSendEmailShow = true;
      }
    },
    onCheckTypeOne() {
      if (this.checkTypeOne) {
        this.checkTypeOne = false;
      } else {
        this.checkTypeOne = true;
      }
    },
    onCheckTypeTwo() {
      if (this.checkTypeTwo) {
        this.checkTypeTwo = false;
      } else {
        this.checkTypeTwo = true;
      }
    },
    sendEmail() {
      if (!this.form.policyNo) {
        return this.$message.warn(this.$t('请选择') + this.$t('保单号'));
      }
      if (!this.form.time.length) {
        return this.$message.warn(this.$t('请选择') + this.$t('日期范围'));
      }
      if (!this.receivingEmails) {
        return this.$message.warn(this.$t('请输入') + this.$t('接收邮箱'));
      } else if (this.receivingEmails) {
        let emailArr = this.receivingEmails.split(',');
        let emailArr2 = emailArr.filter(item => {
          return item && !checkEmail(item);
        });
        if (emailArr2 !== null && emailArr2 !== void 0 && emailArr2.length) {
          return this.$message.warn(this.$t('请输入正确的邮箱地址'));
        }
      }
      let fileType = '';
      if (!this.checkTypeOne && !this.checkTypeTwo) {
        return this.$message.warn(this.$t('请选择') + this.$t('文件类型'));
      } else if (this.checkTypeOne && this.checkTypeTwo) {
        fileType = 'ENDORSEMENT,PERSONNEL_DETAIL';
      } else if (this.checkTypeOne) {
        fileType = 'ENDORSEMENT';
      } else if (this.checkTypeTwo) {
        fileType = 'PERSONNEL_DETAIL';
      }
      let params = {
        customerId: this.form.customerId,
        createAt: moment(this.form.time[0]).format('YYYY-MM-DD'),
        endAt: moment(this.form.time[1]).format('YYYY-MM-DD'),
        policyNo: this.form.policyNo,
        anchorPoint: 'POLICY_GENERATE_SEND',
        receivingEmails: this.receivingEmails,
        fileType: fileType
      };
      this.loading = true;
      this.tipVisible = true;
      this.$set(this.requestInfo, 'type', 'preview');
      this.$set(this.requestInfo, 'loadingTip', '邮件发送生成中,请耐心等待 不要退出该页面');
      this.importStatus = '';
      exportSendEmail(params).then(res => {
        console.log('转发到邮箱请求接口返回的数据');
        console.log(res);
        this.loading = false;
        if (res) {
          this.importStatus = 'SUCCESS';
          this.completeTitle = '邮件发送成功';
        }
      }).catch(e => {
        this.loading = false;
        this.importStatus = 'ERROR';
        this.completeTitle = '邮件发送失败';
      });
    },
    close() {
      this.$emit('cancel');
      this.isSendEmailShow = false;
      this.receivingEmails = '';
      this.checkTypeOne = false;
      this.checkTypeTwo = false;
    }
  }
};